/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents a recommended measure to improve the energy efficiency of the property, including estimated savings and costs.
 */
export interface RdSAPSuggestedImprovementUIDTOV0 { 
    /**
     * The order or priority of the improvement suggestion.
     */
    readonly sequence?: number;
    /**
     * A broad classification of the type of suggested improvement.
     */
    readonly improvementCategory?: number;
    /**
     * The category of the improvement as defined by the Green Deal initiative.
     */
    readonly greenDealCategory?: number;
    /**
     * The specific type of improvement suggested.
     */
    readonly improvementType?: string;
    /**
     * The typical annual saving in currency units that can be expected from the improvement.
     */
    readonly typicalSaving?: number;
    /**
     * The currency in which the typical saving is denominated.
     */
    readonly typicalSavingCurrency?: string;
    /**
     * The estimated cost range for implementing the suggested improvement.
     */
    readonly indicativeCost?: string;
    /**
     * The expected energy performance rating after implementing the improvement.
     */
    readonly energyPerformanceRating?: number;
    /**
     * The expected environmental impact rating after the improvement is made.
     */
    readonly environmentalImpactRating?: number;
    /**
     * A unique identifier for the suggested improvement.
     */
    readonly improvementNumber?: number;
    /**
     * A detailed explanation of the improvement and its benefits.
     */
    readonly improvementDescription?: string | null;
    /**
     * A short description of the suggested improvement.
     */
    readonly improvementTypeDescription?: string | null;
}

